<template>
  <v-container grid-list-md>
    <v-layout>
      <v-layout wrap>
        <v-flex xs12>
          <v-flex xm12 md4 offset-md4 class="text-sm-center">
            <span class="headline">{{ $route.params.committee }} SCHEDULE</span><br />
          </v-flex>
        </v-flex>

        <v-flex xs12 md4>
          <v-card>
            <v-toolbar color="blue" dark>
              <v-toolbar-title>My Schedule</v-toolbar-title>
            </v-toolbar>
            <v-list two-line>
              <template v-for="(item, index) in mySched" >
                <v-list-tile
                  :key="item.id"
                  ripple
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.formatDate }} ({{ item.start }} - {{ item.end }})</v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary">{{ item.committeeName }} - {{ item.name }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title>{{ item.notes }}</v-list-tile-sub-title>
                  </v-list-tile-content>

                </v-list-tile>
                <v-divider
                  v-if="index + 1 < mySched.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex xs12 md8>
          <v-container>
            <v-layout row wrap>
              <v-flex xm12 class="title">
                <v-autocomplete
                  :items="committeeList"
                  item-text="name"
                  item-value="id"
                  v-model="committeeId"
                  label="Choose a committee"
                  hide-details
                  @change="getSchedule()"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex
            v-for="schedule in schedules"
            :key="schedule.id"
            xs12
          >
            <v-toolbar color="blue" dark>
              <v-toolbar-title>{{ schedule.Name }}</v-toolbar-title>
            </v-toolbar>
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex
                    v-for="scheduleDay in schedule.ScheduleDays"
                    :key="scheduleDay.id"
                    xs12 lg6 xl3
                  >
                    <v-card color="blue lighten-5">
                      <v-card-title primary-title class="blue--text">
                        <div color="primary" class="title">{{ scheduleDay.formatDate }}</div>
                      </v-card-title>

                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex
                            v-for="schedule in scheduleDay.Schedules"
                            :key="schedule.id"
                            xs12
                          >
                            <v-card>
                              <v-card-title primary-title>
                                <v-list-tile-title class="title">{{ schedule.name }}</v-list-tile-title>
                                <v-list-tile-sub-title class="subheading">{{ schedule.start }} - {{ schedule.end }}</v-list-tile-sub-title>
                                <v-list-tile-sub-title class="subheading">({{ schedule.quantity }} people required)</v-list-tile-sub-title>
                                <div class="body-2">{{ schedule.notes }}</div>
                              </v-card-title>

                              <v-card-text>
                                <div class="subheading">Members</div>

                                <v-list dense>
                                  <v-list-tile
                                    v-for="item in schedule.Users"
                                    :key="item.id"
                                  >
                                    <v-list-tile-content>
                                      <v-list-tile-title v-if="item.id === myId" class="font-weight-bold">{{ item.fullName }}</v-list-tile-title>
                                      <v-list-tile-title v-else>{{ item.fullName }}</v-list-tile-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-list>
                              </v-card-text>

                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <div class="red--text" v-if="schedule.status === 'Full'">FULL</div>
                                <div class="blue--text" v-else-if="schedule.status === 'Scheduled' && item.id !== myId">SCHEDULED</div>
                                <v-btn v-else @click="saveMember(schedule)">
                                  Add to Schedule
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>

              <!-- <v-flex
                v-for="schedule in schedules"
                :key="schedule.id"
                xs12 md4
              >
                <v-card>
                  <v-card-title primary-title>
                    <div>
                      <div class="title">{{ schedule.name }} ({{ schedule.quantity }} people required)</div>
                      <span class="subheading">{{ schedule.formatDate }} ({{ schedule.start }} - {{ schedule.end }})</span><br />
                      <span class="subheading font-italic">{{ schedule.notes }}</span>
                    </div>
                  </v-card-title>

                  <v-card-text>
                    <v-list>
                      <v-list-tile
                        v-for="item in schedule.Users"
                        :key="item.id"
                      >
                        <v-list-tile-content>
                          <v-list-tile-title v-if="item.id === myId" class="font-weight-bold">{{ item.fullName }}</v-list-tile-title>
                          <v-list-tile-title v-else>{{ item.fullName }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="red--text" v-if="schedule.status === 'Full'">FULL</div>
                    <div class="blue--text" v-else-if="schedule.status === 'Scheduled'">SCHEDULED</div>
                    <v-btn v-else @click="saveMember(schedule)">
                      Add to Schedule
                    </v-btn>
                  </v-card-actions>
                </v-card> -->
              <!-- </v-flex> -->
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>

      <v-dialog v-model="dialog" max-width="1000px" persistent>
      <v-card >
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit Schedule</v-toolbar-title>
        </v-toolbar>

        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
        <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.name"
                    label="Name"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="editedItem.date"
                    label="Date"
                    required
                    mask="##/##/####"
                    return-masked-value
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    :items="theTimes"
                    v-model="editedItem.startTime"
                    label="Start Time"
                    prepend-icon="access_time"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    :items="theTimes"
                    v-model="editedItem.endTime"
                    label="End Time"
                    prepend-icon="access_time"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="editedItem.quantity"
                    label="No of people required"
                    required
                    mask="###"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="editedItem.notes"
                    label="Notes"
                    prepend-icon="notes"
                    required
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          <v-alert :value="error" type="warning" transition="scale-transition">
            <span v-html="error"></span>
          </v-alert>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">Save</v-btn>
        </v-card-actions>
      </v-form>
      </v-card>
    </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import Api from '@/services/Api'
import Utilities from '@/services/Utilities'
import moment from 'moment'

export default {
  data () {
    return {
      myId: this.$store.state.user.id,
      valid: true,
      dialog: false,
      error: '',
      currentYear: 0,
      committeeId: 0,
      saving: false,
      statuses: ['Pending', 'Active'],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedItem: {},
      userId: '',
      titleName: '',
      config: {},
      schedules: [],
      committeeList: [],
      myInfo: {},
      mySched: [],
      theTimes: [
        '6:00 am',
        '6:15 am',
        '6:30 am',
        '6:45 am',
        '7:00 am',
        '7:15 am',
        '7:30 am',
        '7:45 am',
        '8:00 am',
        '8:15 am',
        '8:30 am',
        '8:45 am',
        '9:00 am',
        '9:15 am',
        '9:30 am',
        '9:45 am',
        '10:00 am',
        '10:15 am',
        '10:30 am',
        '10:45 am',
        '11:00 am',
        '11:15 am',
        '11:30 am',
        '11:45 am',
        '12:00 pm',
        '12:15 pm',
        '12:30 pm',
        '12:45 pm',
        '1:00 pm',
        '1:15 pm',
        '1:30 pm',
        '1:45 pm',
        '2:00 pm',
        '2:15 pm',
        '2:30 pm',
        '2:45 pm',
        '3:00 pm',
        '3:15 pm',
        '3:30 pm',
        '3:45 pm',
        '4:00 pm',
        '4:15 pm',
        '4:30 pm',
        '4:45 pm',
        '5:00 pm',
        '5:15 pm',
        '5:30 pm',
        '5:45 pm',
        '6:00 pm',
        '6:15 pm',
        '6:30 pm',
        '6:45 pm',
        '7:00 pm',
        '7:15 pm',
        '7:30 pm',
        '7:45 pm',
        '8:00 pm',
        '8:15 pm',
        '8:30 pm',
        '8:45 pm',
        '9:00 pm',
        '9:15 pm',
        '9:30 pm',
        '9:45 pm',
        '10:00 pm',
        '10:15 pm',
        '10:30 pm',
        '10:45 pm',
        '11:00 pm',
        '11:15 pm',
        '11:30 pm',
        '11:45 pm',
        '12:00 am',
        '12:15 am',
        '12:30 am',
        '12:45 am',
        '1:00 am',
        '1:15 am',
        '1:30 am',
        '1:45 am',
        '2:00 am',
        '2:15 am',
        '2:30 am',
        '2:45 am',
        '3:00 am',
        '3:15 am',
        '3:30 am',
        '3:45 am',
        '4:00 am',
        '4:15 am',
        '4:30 am',
        '4:45 am',
        '5:00 am',
        '5:15 am',
        '5:30 am',
        '5:45 am'
      ]
    }
  },

  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    }
  },

  created () {
    this.titleName = this.$store.state.user.Title.name
    this.currentYear = this.$store.state.currentYear
    let committeeId = Number(this.$route.params.committeeId)
    this.committeeId = Number(committeeId)
    this.getCommittees()
    if (this.committeeId > 0) {
      this.getSchedule()
    }
    // this.mySchedule()
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      }
    }
  },

  methods: {
    addNew () {
      this.dialog = true
    },

    editSchedule (schedule) {
      this.editedItem = schedule
      this.editedItem.date = this.editedItem.formatDate
      this.editedItem.startTime = this.editedItem.start
      this.editedItem.endTime = this.editedItem.end
      this.dialog = true
    },

    loadItem () {
      this.editedItem = this.item

      this.formattedDate = moment(this.editedItem.birthDate).format('MM/DD/YYYY')
    },

    formatDate (date) {
      return Utilities.displayDate(date)
    },

    async getSchedule () {
      try {
        let schedules = []
        let push = false

        const response = await Api().get('/comm_schedules/' + this.committeeId)
        console.log(response.data)

        this.schedules = response.data

        for (let i in this.schedules) {
          for (let j in this.schedules[i].ScheduleDays) {
            const [year, month, day] = this.schedules[i].ScheduleDays[j].Num.split('-')
            this.schedules[i].ScheduleDays[j].formatDate = `${month}/${day}/${year}`

            for (let k in this.schedules[i].ScheduleDays[j].Schedules) {
              this.schedules[i].ScheduleDays[j].Schedules[k].start = moment(this.schedules[i].ScheduleDays[j].Schedules[k].startTime, 'HH:mm').format('h:mm a')
              this.schedules[i].ScheduleDays[j].Schedules[k].end = moment(this.schedules[i].ScheduleDays[j].Schedules[k].endTime, 'HH:mm').format('h:mm a')
              this.schedules[i].ScheduleDays[j].Schedules[k].userId = ''
              this.schedules[i].status = ''
              this.schedules[i].userId = ''

              let users = this.schedules[i].ScheduleDays[j].Schedules[k].Users

              if (this.schedules[i].ScheduleDays[j].Schedules[k].quantity <= users.length) {
                this.schedules[i].ScheduleDays[j].Schedules[k].status = 'Full'
              }

              for (let j in users) {
                if (this.myId === users.id) {
                  this.schedules[i].ScheduleDays[j].Schedules[k].status = 'Scheduled'
                }
              }

              push = true
            }
          }

          if (push) {
            schedules.push(this.schedules[i])
          }

          push = false
        }

        schedules = schedules.sort((a, b) => a.Num - b.Num)
        console.log(schedules)
        this.schedules = schedules

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async mySchedule () {
      try {
        let today = moment().format('YYYY-MM-DD')
        let mySched = []

        const response = await Api().get('/my_schedule/' + this.myId)
        this.myInfo = response.data[0]

        for (let i in this.myInfo.Schedules) {
          // console.log(this.myInfo.Schedules[i].date, today)
          if (this.myInfo.Schedules[i].date > today) {
            mySched.push(this.myInfo.Schedules[i])
          }
        }

        // console.log('mySched', mySched)
        this.mySched = mySched

        this.mySched.sort(function (a, b) {
          let nameA = a.startTime.toLowerCase()
          let nameB = b.startTime.toLowerCase()

          if (nameA < nameB) {
            return -1
          }

          if (nameA > nameB) {
            return 1
          }

          return 0
        })

        this.mySched.sort(function (a, b) {
          let nameA = a.date.toLowerCase()
          let nameB = b.date.toLowerCase()

          if (nameA < nameB) {
            return -1
          }

          if (nameA > nameB) {
            return 1
          }

          return 0
        })

        for (let i in this.mySched) {
          let item = {}
          item = this.committeeList.find(item => item.id === this.mySched[i].CommitteeId)
          console.log('list', this.committeeList)
          console.log('committee', this.mySched[i].CommitteeId, item)
          this.mySched[i].committeeName = item.name

          const [year, month, day] = this.mySched[i].date.split('-')
          this.mySched[i].formatDate = `${month}/${day}/${year}`

          this.mySched[i].start = moment(this.mySched[i].startTime, 'HH:mm').format('h:mm a')
          this.mySched[i].end = moment(this.mySched[i].endTime, 'HH:mm').format('h:mm a')
          this.mySched[i].userId = ''
        }

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getCommittees () {
      try {
        const response = await Api().get('/get_committeelist/' + this.currentYear)
        this.committeeList = response.data
        this.mySchedule()
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async saveMember (schedule) {
      try {
        schedule.scheduleId = schedule.id
        schedule.userId = this.myId
        schedule.status = 'Not on committee'

        if (this.myInfo.Committees.some(e => e.id === schedule.CommittedId)) {
          schedule.status = 'Yes'
        }

        const response = await Api().post('member_schedules/', schedule)

        this.getSchedule(0)
        this.mySchedule()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteMember (scheduleId, userId) {
      try {
        const response = await Api().delete('member_schedules/' + scheduleId + '/' + userId)

        this.getSchedule()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async printForm (date) {
      try {
        await Api().post('get_pdf/' + this.editedItem.id, this.editedItem).then((response) => {
          window.open(process.env.API_URL + '/attachments/' + this.editedItem.id + 'app.pdf', '_blank')

          // console.log(route)
          console.log(response)
        })
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    save () {
      if (this.$refs.form.validate()) {
        if (this.editedItem.id > 0) {
          // console.log('Update')
          this.updateItem(this.editedItem)
        } else {
          // console.log('Save')
          this.addItem(this.editedItem)
        }
      } else {
        this.snackbar.message = 'You have some errors on the page!'
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async addItem () {
      try {
        this.editedItem.CommitteeId = this.$route.params.committeeId
        const [month, day, year] = this.editedItem.date.split('/')
        this.editedItem.date = `${year}-${month}-${day}`

        this.editedItem.startTime = moment(this.editedItem.startTime, 'h:mm a').format('HH:mm')
        this.editedItem.endTime = moment(this.editedItem.endTime, 'h:mm a').format('HH:mm')

        const response = await Api().post('comm_schedules/', this.editedItem)
        this.message = response.data.message
        this.getSchedule()
        this.dialog = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem () {
      try {
        this.editedItem.CommitteeId = this.$route.params.committeeId
        const [month, day, year] = this.editedItem.date.split('/')
        this.editedItem.date = `${year}-${month}-${day}`

        this.editedItem.startTime = moment(this.editedItem.startTime, 'h:mm a').format('HH:mm')
        this.editedItem.endTime = moment(this.editedItem.endTime, 'h:mm a').format('HH:mm')

        const response = await Api().put('comm_schedules/' + this.editedItem.id, this.editedItem)
        this.getSchedule()
        this.dialog = false

        this.message = response.data.message
        this.show = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    close () {
      this.editedItem = {}
      this.dialog = false
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/myschedule/List.vue